import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { BaseError, BaseResponse } from '@utils/types/shared/base';
import { CustomerBo } from '@utils/types/back-office/customers';

export type ResellersBoResponse = BaseResponse<CustomerBo[]>;

/**
 * Hook to search resellers with a query parameter.
 * Used for search inputs where we need backend filtering without URL param dependency.
 *
 * Note: Backend requires separate q parameters for each filter condition.
 */
export const useSearchResellersBo = (searchTerm?: string) => {
  const fetchResellers = async () => {
    // Build URL with separate q parameters for each filter
    // Backend doesn't support comma-separated filters in single q param
    const params = new URLSearchParams();
    params.append('offset', '0');
    params.append('limit', '50');
    params.append('q', 'is_reseller:eq:true');

    if (searchTerm?.trim()) {
      params.append('q', `name:ilike:%${searchTerm.trim()}%`);
    }

    const url = `/api/v3/admin/customer?${params.toString()}`;
    const { data } = await Axios.get<ResellersBoResponse>(url);
    return data;
  };

  return useQuery<ResellersBoResponse, AxiosError<BaseError>>(
    ['searchResellersBo', searchTerm],
    fetchResellers,
    {
      keepPreviousData: true,
      useErrorBoundary: false,
      staleTime: 30 * 1000 // 30 seconds
    }
  );
};
